module.exports = __webpack_public_path__ + "images/emoji/blue_book.6f5c747d2d5b35472c00.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/blue_book.png
// module id = olBS
// module chunks = 2